import { DELETE_USER_SUCCESS } from '../../users/constants';

const byId = (state = {}, action) => {
  if (action.response) {
    return {
      ...state,
      ...action.response.entities.shops,
    };
  }

  if (action.type === DELETE_USER_SUCCESS) {
    const affected = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const shopId in state) {
      if (Object.prototype.hasOwnProperty.call(state, shopId) && state[shopId].users) {
        affected[shopId] = {
          ...state[shopId],
          users: state[shopId].users.filter(user => user.id !== action.payload),
        };
      }
    }

    return {
      ...state,
      ...affected,
    };
  }

  return state;
};

export default byId;
